<template>
<nav class='menu'>
  <img
    id='logo1'
    class='logo'
    :src="imgLeft"
  >
  <h1 v-if="showProgress" class="progress-text">{{ index }} de {{ total }}</h1>
  <img
    id='logo2'
    class='logo'
    style="float: right"
    :src="imgRight"
  >
</nav>
</template>

<script>
export default {
  name: 'nav-top-presenter',

  props: {
    imgLeft: {
      default: require('../assets/img/trg-logo.svg')
    },
    imgRight: {
      default: require('../assets/img/trg-logo.svg')
    },
    total: {
      default: 0
    },
    showProgress: {
      default: false
    },
    index: {
      default: 0
    }
  }
}
</script>

<style scoped>
.menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.progress-text {
  align-self: center;
  font-weight: bold;
  color: #606464;
}
</style>



// WEBPACK FOOTER //
// src/components/NavTopPresenter.vue